import { render, staticRenderFns } from "./KeyGroupHandToHand.vue?vue&type=template&id=7fe81536&"
import script from "./KeyGroupHandToHand.vue?vue&type=script&lang=ts&"
export * from "./KeyGroupHandToHand.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports